function updateThemeLogos(theme) {
    const logoSrc = theme === 'dark' ? 'data-logo-dark' : 'data-logo-light';

    document.querySelectorAll('.js-theme-logo').forEach((logo) => {
        const nextSrc = logo.getAttribute(logoSrc);

        if (nextSrc && logo.getAttribute('src') !== nextSrc) {
            logo.setAttribute('src', nextSrc);
        }
    });
}

const THEME_ORDER = ['light', 'dark', 'system'];
const THEME_ICONS = {light: 'bi-sun-fill', dark: 'bi-moon-fill', system: 'bi-circle-half'};
const systemDarkQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

function resolveTheme(preference) {
    if (preference === 'system') {
        return systemDarkQuery && systemDarkQuery.matches ? 'dark' : 'light';
    }

    return preference === 'dark' ? 'dark' : 'light';
}

function currentThemePreference() {
    const preference = $('html').attr('data-theme-pref') || localStorage.getItem('theme') || 'light';

    return THEME_ORDER.includes(preference) ? preference : 'light';
}

function applyTheme(preference) {
    const theme = resolveTheme(preference);

    $('html, body').attr('data-bs-theme', theme);
    $('html').attr('data-theme-pref', preference);
    updateThemeLogos(theme);
    $('.theme-icon')
        .removeClass('bi-moon-fill bi-sun-fill bi-circle-half')
        .addClass(`bi ${THEME_ICONS[preference] || THEME_ICONS.light}`);
}

function layoutSetTheme(preference, save = false) {
    window.Taskello.debug.log('Zmiana szablonu', preference, save);

    if (window.location.pathname === '/login' || window.location.pathname === '/register') {
        return;
    }

    const previousPreference = currentThemePreference();

    applyTheme(preference);
    localStorage.setItem('theme', preference);

    if (save) {
        $.post(`/accounts/changeTheme/${preference}`)
            .fail(() => {
                layoutSetTheme(previousPreference);
                window.Taskello.debug.error('Błąd zmiany szablonu', preference, save);
            });
    }
}

$(document).ready(function () {
    layoutSetTheme(currentThemePreference());

    $(document).on('click', '.theme-toggle', function () {
        const next = THEME_ORDER[(THEME_ORDER.indexOf(currentThemePreference()) + 1) % THEME_ORDER.length];
        layoutSetTheme(next, true);
    });

    if (systemDarkQuery) {
        systemDarkQuery.addEventListener('change', function () {
            if (currentThemePreference() === 'system') {
                applyTheme('system');
            }
        });
    }
})
